import React, { RefObject } from 'react';
import * as mobxReact from 'mobx-react';
import OECheckbox from '../../../../../global/oe-checkbox/oe-checkbox';
import './date-filter.scss';
import ReportsViewModel from '../../../_reports/reports.viewmodel';
import Text from '../../../../../global/text/text';
import DatePicker from 'react-datepicker';
import { SELECT_ALL_TEXT } from '../../../../../../constants/common-labels.constants';
import CustomDatePickerHeader, { DatePickerHeaderProps } from '../../custom-date-picker-header/custom-date-picker-header';

interface IProps {
    vm: ReportsViewModel;
    ContentHeader: JSX.Element;
    headerHeight: string;
    headerRef: RefObject<HTMLDivElement>;
}

const DateFilter = mobxReact.observer((props: IProps) => {
    const {
        vm,
        ContentHeader,
        headerHeight,
        headerRef
    } = props;

    const availableDates = vm.getAvailableDates().map(d => d.dateNumber);

    const minDate = new Date(vm.getMinAvailableDate());
    const maxDate = new Date(vm.getMaxAvailableDate());

    const isChecked = (
        !!availableDates.length &&
        vm.getMinAvailableDate() === vm.firstSelectedDate?.getTime() &&
        vm.getMaxAvailableDate() === vm.lastSelectedDate?.getTime()
    );

    return (
        <div className='date-filter'>
            <div className='date-filter__header' ref={headerRef}>
                {ContentHeader}
                <Text className='checkbox-filter__operator' message='Includes:' />
                <OECheckbox
                    checked={isChecked}
                    onChange={vm.selectAll}
                    label={vm.intl.formatMessage(SELECT_ALL_TEXT)}
                    isDisabled={!vm.getAvailableDates().length}
                    classNames='oe-form-field__checkbox date-filter__checkbox'
                />
            </div>
            <div className='date-filter__dates' style={{ height: headerHeight }}>
                <DatePicker
                    renderCustomHeader={(headerProps: DatePickerHeaderProps) => (
                        <CustomDatePickerHeader
                            {...headerProps}
                            minDate={minDate}
                            maxDate={maxDate}
                        />
                    )}
                    selected={vm.firstSelectedDate}
                    onChange={vm.selectDates}
                    startDate={vm.firstSelectedDate}
                    endDate={vm.lastSelectedDate}
                    monthsShown={2}
                    minDate={minDate}
                    maxDate={maxDate}
                    includeDates={availableDates}
                    selectsRange
                    inline
                    disabledKeyboardNavigation
                />
            </div>
        </div>
    );
});

export default DateFilter;
